import { useCallback, useMemo } from 'react';
import { useShipmentGroupConfigurations } from './useShipmentGroupConfigurations';
import { useInternalShipmentGroups } from './useInternalShipmentGroups';
import {
  generateShipmentGroups,
  createShipmentGroupMap,
} from '../../utils/shipment-groups/shipmentGroupGenerator';

export const useShipmentGroups = () => {
  const {
    getShipmentGroupConfigurations,
    shipmentGroupConfigurations,
    isShipmentGroupConfigurationsLoading,
  } = useShipmentGroupConfigurations();

  const {
    getInternalShipmentGroups,
    internalShipmentGroups,
    isInternalShipmentGroupsLoading,
  } = useInternalShipmentGroups();

  const isShipmentGroupsLoading = useMemo(
    () => isShipmentGroupConfigurationsLoading || isInternalShipmentGroupsLoading,
    [isShipmentGroupConfigurationsLoading, isInternalShipmentGroupsLoading],
  );

  const shipmentGroupConfigurationMap = useMemo(
    () => createShipmentGroupMap(shipmentGroupConfigurations),
    [shipmentGroupConfigurations],
  );

  const { shipmentGroups, unsortedShipmentCount, sortedShipmentCount } = useMemo(
    () => generateShipmentGroups(internalShipmentGroups, shipmentGroupConfigurationMap),
    [internalShipmentGroups, shipmentGroupConfigurationMap],
  );

  const getShipmentGroups = useCallback(
    () => {
      getInternalShipmentGroups();
      getShipmentGroupConfigurations();
    },
    [getInternalShipmentGroups, getShipmentGroupConfigurations],
  );

  return {
    shipmentGroups,
    getShipmentGroups,
    isShipmentGroupsLoading,
    unsortedShipmentCount,
    sortedShipmentCount,
  };
};
